import { Button } from '~/components';
import { getTheme, styled } from '~/modules';

const smSpacing = getTheme('spacing.sm');

export const ButtonComponent = styled(Button)`
  width: 100%;
  margin: auto;
`;

export const FooterWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${smSpacing}px;
`;
